import { client } from '../../graphql/client';
import {getSelectedTenant} from "../../service/store";
import {SearchMessages} from "../../graphql/generated-queries/search-messages-queries";

export async function getMessages(input) {

  const variables = {
    ...input.filter,
    perPage: input.pagination.perPage,
    skip: (input.pagination.page - 1) * input.pagination.perPage,
  }
  if (input.sort && input.sort.field) {
    variables.order = [
      {[input.sort.field]: input.sort.order}
    ]
  }

  const tenant = getSelectedTenant();
  const tenantId = tenant ? tenant.tenantId : null;

  try {
    const { data } = await client.query({ query: SearchMessages, variables: {...variables, tenantId } } );
    return { data: data.searchMessages.items, total: data.searchMessages.total };
  } catch (err) {
    console.error(err);
  }
}
